import React, {Component} from 'react'
import CalendarEditForm from './components/CalendarEditFormComponent.jsx';
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SideBar from '../common/layout/sidebar.component.jsx'

class CalendarEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            calendarTitle: '',
            form: '',
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        const calendarId = this.props.match.params.calendarId
        AppContext.getApiClient().get('/calendars/' + calendarId).then((calendar) => {
            const calendarForm = <CalendarEditForm calendar={calendar} />
            this.setState({
                calendarTitle: calendar.attributes.title,
                form: calendarForm
            })
        });
    }

    render() {
        return (
            <div>
                {this.state.form}
            </div>
        );
    }
}

export default CalendarEdit


// WEBPACK FOOTER //
// ./src/calendar/edit.component.jsx